// extracted by mini-css-extract-plugin
export var container = "_gu-0";
export var dotAnimation = "_gu-2";
export var dotsLoading = "_gu-1";